import { Controller } from "@hotwired/stimulus"

// Il pannello «Il bando è «Da revisionare»…» di pages/VerificaBandi.js (stato `controllo`): «Segna come verificato»
// lo apre, «Annulla» lo chiude. Come lo stato di React, resta aperto quando la scheda è riletta con morph, finché il
// server lo rende (il bando è ancora «Da revisionare»); dopo una verifica riuscita la scheda riletta lo chiude.
export default class extends Controller {
  static targets = ["pannello"]

  connect() {
    this.aperto = this.hasPannelloTarget && !this.pannelloTarget.hidden
  }

  mostra() {
    this.aperto = true
    this.applica()
  }

  annulla() {
    this.aperto = false
    this.applica()
  }

  // turbo:morph-element del pannello. Dopo «Ho controllato queste ragioni» riuscito il server non lo rende più.
  riletto(event) {
    if (!this.hasPannelloTarget || event.target !== this.pannelloTarget) return
    this.applica()
  }

  // la risposta riuscita di «Ho controllato queste ragioni sugli atti»: setControllo(false)
  inviato(event) {
    if (event.detail.success) this.annulla()
  }

  applica() {
    if (this.hasPannelloTarget) this.pannelloTarget.hidden = !this.aperto
  }
}
